module.exports = __webpack_public_path__ + "static/media/Logo-KZVB-RGB.5f012c01.svg";